module.exports = __webpack_public_path__ + "img/6diamante.ff1c6299.png";